export const FETCH_SCREENED_PATIENT_LIST_REQUEST = 'FETCH_SCREENED_PATIENT_LIST_REQUEST';
export const FETCH_SCREENED_PATIENT_SUCCESS = 'FETCH_SCREENED_PATIENT_SUCCESS';
export const FETCH_SCREENED_PATIENT_FAILURE = 'FETCH_SCREENED_PATIENT_FAILURE';
export const FETCH_ENROLLED_PATIENT_REQUEST = 'FETCH_ENROLLED_PATIENT_REQUEST';
export const FETCH_ENROLLED_PATIENT_SUCCESS = 'FETCH_ENROLLED_PATIENT_SUCCESS';
export const FETCH_ENROLLED_PATIENT_FAILURE = 'FETCH_ENROLLED_PATIENT_FAILURE';
export const FETCH_ASSESSMENT_LIST_REQUEST = 'FETCH_ASSESSMENT_LIST_REQUEST';
export const FETCH_ASSESSMENT_LIST_SUCCESS = 'FETCH_ASSESSMENT_LIST_SUCCESS';
export const FETCH_ASSESSMENT_LIST_FAILURE = 'FETCH_ASSESSMENT_LIST_FAILURE';
export const FETCH_USER_PERFORMANCE_LIST_REQUEST = 'FETCH_USER_PERFORMANCE_LIST_REQUEST';
export const FETCH_USER_PERFORMANCE_LIST_SUCCESS = 'FETCH_USER_PERFORMANCE_LIST_SUCCESS';
export const FETCH_USER_PERFORMANCE_LIST_FAILURE = 'FETCH_USER_PERFORMANCE_LIST_FAILURE';
export const FETCH_SS_REPORT_VIEW_REQUEST = 'FETCH_SS_REPORT_VIEW_REQUEST';
export const FETCH_SS_REPORT_VIEW_SUCCESS = 'FETCH_SS_REPORT_VIEW_SUCCESS';
export const FETCH_SS_REPORT_VIEW_FAILURE = 'FETCH_SS_REPORT_VIEW_FAILURE';
export const FETCH_SK_REPORT_VIEW_REQUEST = 'FETCH_SK_REPORT_VIEW_REQUEST';
export const FETCH_SK_REPORT_VIEW_SUCCESS = 'FETCH_SK_REPORT_VIEW_SUCCESS';
export const FETCH_SK_REPORT_VIEW_FAILURE = 'FETCH_SK_REPORT_VIEW_FAILURE';
export const FETCH_SK_DETAILS_LIST_REQUEST = 'FETCH_SK_DETAILS_LIST_REQUEST';
export const FETCH_SK_DETAILS_LIST_SUCCESS = 'FETCH_SK_DETAILS_LIST_SUCCESS';
export const FETCH_SK_DETAILS_LIST_FAILURE = 'FETCH_SK_DETAILS_LIST_FAILURE';
export const FETCH_SK_DETAILS_VIEW_REQUEST = 'FETCH_SK_DETAILS_VIEW_REQUEST';
export const FETCH_SK_DETAILS_VIEW_SUCCESS = 'FETCH_SK_DETAILS_VIEW_SUCCESS';
export const FETCH_SK_DETAILS_VIEW_FAILURE = 'FETCH_SK_DETAILS_VIEW_FAILURE';
export const CLEAR_SK_DETAILS_VIEW = 'CLEAR_SK_DETAILS_VIEW';
